import state from "@/store/modules/budget-template/state";
import actions from "@/store/modules/budget-template/actions";
import mutations from "@/store/modules/budget-template/mutations";
import getters from "@/store/modules/budget-template/getters";


export default {
  state,
  actions,
  mutations,
  getters
}